<div class="yllw-nav-context" [class.yllw-nav-context--collapsed]="!expanded()">
    <a class="yllw-nav-context__back" [routerLink]="backRoute()" pRipple
       [pTooltip]="backLabel() | translate" tooltipPosition="right" [tooltipDisabled]="expanded()">
        <i class="pi pi-angle-left yllw-nav-context__back-icon"></i>
        @if (expanded()) { <span class="yllw-nav-context__back-label">{{ backLabel() | translate }}</span> }
    </a>
    @if (expanded() && !hideIdentity()) {
        @if (loading()) {
            <div class="yllw-nav-context__identity">
                <p-skeleton width="60%" height="1rem" />
                <p-skeleton width="40%" height="0.75rem" styleClass="mt-1" />
            </div>
        } @else {
            <div class="yllw-nav-context__identity">
                <div class="yllw-nav-context__title-row">
                    <span class="yllw-nav-context__title">{{ title() }}</span>
                    @if (locked()) {
                        <i class="pi pi-lock yllw-nav-context__lock"
                           [pTooltip]="lockTooltip()" tooltipPosition="right" [tooltipDisabled]="!lockTooltip()"></i>
                    }
                </div>
                @if (subtitle()) { <span class="yllw-nav-context__subtitle">{{ subtitle() }}</span> }
                @if (statusLabel()) {
                    <p-tag class="yllw-nav-context__status" [value]="statusLabel()!" [icon]="statusIcon() ?? undefined"
                           [severity]="statusSeverity() ?? undefined" [rounded]="true" />
                }
            </div>
        }
    }
</div>
